// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RateTypeCell-Contract {
  margin-top: -5px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Rates/components/RateTypeCell/styles.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF","sourcesContent":[".RateTypeCell-Contract {\n  margin-top: -5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
